import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";
import { HomeComponent } from "./home/home.component";
import { QuestionListComponent } from "./home/question-list/question-list.component";
import { ProfileComponent } from "./home/profile/profile.component";
import { ChoirDetailComponent } from "./home/choir-detail/choir-detail.component";
import { SavedChoirsComponent } from "./home/saved-choirs/saved-choirs.component";
import { ViewBookingsComponent } from "./home/view-bookings/view-bookings.component";
import { NewsletterComponent } from "./home/newsletter/newsletter.component";
import { UniformSectionComponent } from "./home/uniform-section/uniform-section.component";
import { ChangePasswordComponent } from "./home/change-password/change-password.component";
import { PendingTansactionsComponent } from "./home/pending-tansactions/pending-tansactions.component";
import { PaymentCardsComponent } from "./home/payment-cards/payment-cards.component";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/home", pathMatch: "full" },
      { component: HomeComponent, path: "home" },
      { path: "question", component: QuestionListComponent },
      { path: "profile", component: ProfileComponent },
      { path: "choir-detail", component: ChoirDetailComponent },
      { path: "saved-choir", component: SavedChoirsComponent },
      { path: "view-booking", component: ViewBookingsComponent },
      { path: "newsletter", component: NewsletterComponent },
      { path: "uniform", component: UniformSectionComponent },
      { path: "change-password", component: ChangePasswordComponent },
      { path: "pending-booking", component: PendingTansactionsComponent },
      { path: "payment-cards", component: PaymentCardsComponent },

      {
        // canActivate: [AuthGuardMain],
        path: "dashboard",
        data: { access: "admin" },
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        // canActivate: [AuthGuardMain],
        path: "application",
        data: { access: "admin" },
        loadChildren: () =>
          import("./application/application.module").then(
            (m) => m.ApplicationModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
